import { createFileRoute } from "@tanstack/react-router";
import { PortalSettingsV2Page } from "@/components/v2/pages/portal-settings-v2-page";

export const Route = createFileRoute("/portal/settings")({
  component: PortalSettingsV2Page,
});
